import { useEffect, useState } from "react"
import { useNetwork } from "../internal-api/network/use-network.hook"
import { NETLIFY_URL } from "../internal-api/commerce/constants"
import { Prices } from "../internal-api/commerce/commerce.interface"

const config = {
  baseURL: NETLIFY_URL,
}

const useServerConnection = () => {
  const skipConnection = Boolean(process.env.NODE_ENV === "production")
  const [connection, setConnection] = useState(skipConnection)
  const [testConnection, testConnectionRequest] = useNetwork<Prices>(
    { url: "/" },
    config
  )

  useEffect(() => {
    if (!skipConnection) {
      testConnectionRequest().catch(() => {
        console.log("Functions are off.")
      })
    }
  }, [])

  useEffect(() => {
    const { loading, error } = testConnection
    const errorExists = error !== null
    const timeout = error?.response?.status === 504

    if (!loading && errorExists && !timeout) {
      setConnection(true)
    }
  }, [testConnection])

  return connection
}

export default useServerConnection
